import { Link } from "react-router-dom";
import { Heart, Sparkles, MapPin, Handshake, ShieldCheck } from "lucide-react";
import { IMG, SERVICE_AREA } from "@/lib/content";

export default function About() {
  return (
    <div>
      <section className="relative h-[42vh] min-h-[320px]">
        <img src={IMG.livingAlt} alt="Warm, welcoming clean home interior" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-end pb-12">
          <p className="text-xs uppercase tracking-[0.25em] text-white/90">About Masaya</p>
          <h1 className="mt-2 font-serif text-4xl sm:text-5xl text-white font-semibold">Hospitality, in every detail</h1>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <p className="text-xl text-[#2C2621] font-serif leading-relaxed">
          Masaya Hospitality Cleaning Services was built on a simple belief: a clean space should feel as welcoming as a great hotel.
        </p>
        <p className="mt-6 text-[#635B52] leading-relaxed text-lg">
          We bring hospitality-grade standards to homes and short-term rentals across {SERVICE_AREA}. Whether we're
          resetting an Airbnb between guests or refreshing your family home, we focus on the details that make a space
          feel truly cared for—crisp linens, spotless surfaces, and a warm, professional touch.
        </p>

        <div className="mt-12 grid sm:grid-cols-2 gap-6">
          {[
            { icon: Heart, t: "Warm & professional", d: "Friendly, respectful service you can rely on." },
            { icon: Sparkles, t: "Detail-obsessed", d: "Hotel-standard results, every visit." },
            { icon: Handshake, t: "Trustworthy", d: "Consistent teams who treat your home with care." },
            { icon: MapPin, t: "Local to Central Texas", d: SERVICE_AREA },
          ].map((v, i) => (
            <div key={i} className="bg-white rounded-2xl border border-[#E6DEC3] p-6 shadow-[0_4px_20px_rgba(44,38,33,0.04)]">
              <v.icon className="text-[#B87333]" size={24} />
              <p className="mt-3 font-semibold text-[#2C2621]">{v.t}</p>
              <p className="mt-1 text-sm text-[#635B52]">{v.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex items-center justify-center">
          <span className="inline-flex items-center gap-2 bg-[#F5F0E8] border border-[#E6DEC3] rounded-full px-5 py-2.5 text-sm font-medium text-[#2C2621]" data-testid="about-insured">
            <ShieldCheck size={16} className="text-[#B87333]" /> Insured — general liability &amp; workers' compensation coverage
          </span>
        </div>

        <div className="mt-14 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/book" className="bg-[#B87333] hover:bg-[#A06127] text-white font-medium rounded-full px-7 py-3 shadow-md transition-all text-center" data-testid="about-book-btn">Book Now</Link>
          <Link to="/contact" className="border border-[#B87333]/40 hover:border-[#B87333] text-[#2C2621] hover:bg-[#F5F0E8] font-medium rounded-full px-7 py-3 transition-all text-center">Contact us</Link>
        </div>
      </div>
    </div>
  );
}
